import * as React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";

export const DropDownCell = (props) => {
    const handleChange = (e) => {
        if (props.onChange) {
            props.onChange({
                dataIndex: 0,
                dataItem: props.dataItem,
                valueField: props.valueField,
                textField: props.textField,
                syntheticEvent: e.syntheticEvent,
                value: e.target.value.value,
                field: props.valueField,
            });
        }
    };

    const { dataItem } = props;
    const textField = props.textField || "";
    const valueField = props.valueField || "";
    const dataText = dataItem[textField] === null ? "" : dataItem[textField];
    const dataValue = dataItem[valueField] === null ? "" : dataItem[valueField];
    return (
        <td>
            {dataItem.inEdit ? (
                <DropDownList
                    onChange={handleChange}
                    value={props.data.find((c) => c.value === dataValue)}
                    data={props.data}
                    textField="text"
                />
            ) : (
                dataText
            )}
        </td>
    );
};